import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchTradeDetailsAction } from '../store/reducer/tradeDetailsSlice';

export const useTradeDetilas = () => {
  const { propertyType = 'secondary', propertyId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const state = useSelector((state) => state.tradeDetails);
  const onFetchFail = () => {
    if (location?.state?.prevPath) {
      navigate(location.state.prevPath);
      return;
    }
    navigate(`/property/${propertyType}/${propertyId}`);
  };
  async function fetchTradeDetails() {
    await dispatch(fetchTradeDetailsAction({ id: propertyId, onFail: onFetchFail }));
  }

  useEffect(() => {
    if (!state.loading) {
      fetchTradeDetails();
    }
  }, [propertyId.loading]);

  return {
    fetchTradeDetails,
  };
};
